import { useState, useReducer, useEffect } from "react";

const initialState = {
  value: "",
  isTouched: false,
};

const handler = (state, action) => {
  switch (action.type) {
    case "INITIALIZE":
      return { value: action.value, isTouched: true };
    case "CHANGE":
      return { value: action.value, isTouched: state.isTouched };
    case "BLUR":
      return { value: state.value, isTouched: true };
    case "CLEAR":
      return { value: "", isTouched: false };
    default:
      return state;
  }
};

export default function useInput(validationFunc, initialValue = "") {
  const [state, dispatch] = useReducer(handler, initialState);

  let inputIsValid = false;
  if (state.isTouched) inputIsValid = validationFunc(state.value);
  const hasError = !inputIsValid && state.isTouched;

  const inputChangeHandler = (event) => {
    dispatch({ type: "CHANGE", value: event.target.value });
  };

  const inputBlurHandler = (event) => {
    dispatch({ type: "BLUR" });
  };

  const resetInput = () => {
    dispatch({ type: "CLEAR" });
  };

  useEffect(() => {
    dispatch({ type: "INITIALIZE", value: initialValue });
  }, [initialValue]);

  return {
    value: state.value,
    isValid: inputIsValid,
    hasError,
    changeHandler: inputChangeHandler,
    blurHandler: inputBlurHandler,
    reset: resetInput,
  };
}
